import { combineReducers } from "redux";
import cryptoWithdrawalsReducer from './crypto-withdrawals'
import onboardingReducer from "./onboarding";
import fiatDepositsReducer from "./fiat-deposits";
import fiatWithdrawalsReducer from "./fiat-withdrawals";
import cryptoBuyReducer from "./crypto-buy";
import cryptoSellReducer from "./crypto-sell";
import fundReducer from "./fund";
import profileReducer from "./profile";
import cryptoAccountLinkReducer from "./crypto-account-link";
import cryptoAccountLinkPayoutsReducer from "./crypto-account-link-payouts";
import payoutsReducer from "./payouts";
import payReducer from "./pay";
import fiatAccountLinkReducer from "./fiat-account-link";

const rootReducer = combineReducers({
  ["crypto-withdrawals"]: cryptoWithdrawalsReducer,
  ["onboarding"]: onboardingReducer,
  ["fiat-deposits"]: fiatDepositsReducer,
  ["fiat-withdrawals"]: fiatWithdrawalsReducer,
  ["crypto-buy"]: cryptoBuyReducer,
  ["crypto-sell"]: cryptoSellReducer,
  ["csp-crypto-withdrawals"]: cryptoWithdrawalsReducer,
  ["csp-fiat-withdrawals"]: fiatWithdrawalsReducer,
  ["csp-crypto-sell"]: cryptoSellReducer,
  ["fund"]: fundReducer,
  ["profile"]: profileReducer,
  ["crypto-account-link"]: cryptoAccountLinkReducer,
  ["crypto-account-link-payouts"]: cryptoAccountLinkPayoutsReducer,
  ["payouts"]: payoutsReducer,
  ["pay"]: payReducer,
  ["fiat-account-link"]: fiatAccountLinkReducer,
});

export default rootReducer;
